import Vue from 'vue'

import { $themeConfig } from '@themeConfig'

const activeNotesInFlight = new Map()

const normalizeNoteDate = date => {
    if (!date) return ''
    const normalizedDate = new Date(date)
    normalizedDate.setSeconds(0, 0)
    return normalizedDate.toISOString()
}

export default {
    async fetchNotes({ commit }, { limit = 10, offset = 0, search = '' }) {
        commit('SET_IS_LOADING', true)

        const params = Object.fromEntries(
            Object.entries({ limit, offset, search }).filter(
                ([, value]) => value
            )
        )
        try {
            const response = await Vue.axios.get(
                `${$themeConfig.app.backUrlDivisions}/notes`,
                { params }
            )
            commit('SET_NOTES', response.data?.notes ?? [])
            commit('SET_TOTAL_NOTES', response.data?.total ?? 0)
        } catch (error) {
            console.error('Ошибка при получении списка примечаний', error)
            throw error
        } finally {
            commit('SET_IS_LOADING', false)
        }
    },

    fetchActiveNote({ commit }, { divisionId, date }) {
        const key = `${divisionId}|${normalizeNoteDate(date)}`
        const inFlight = activeNotesInFlight.get(key)
        if (inFlight) return inFlight

        const request = Vue.axios
            .get(`${$themeConfig.app.backUrlDivisions}/notes`, {
                params: {
                    division_id: divisionId,
                    time: date,
                },
            })
            .then(response => {
                commit(
                    'SET_ACTIVE_NOTE',
                    response.data.notes.length ? response.data.notes[0] : null
                )
                return response.data
            })
            .catch(error => {
                console.error(error)
                throw error
            })
            .finally(() => {
                activeNotesInFlight.delete(key)
            })
        activeNotesInFlight.set(key, request)
        return request
    },

    fetchNoteHistory({ commit }, { noteId, limit = 5, offset = 0 }) {
        const params = Object.fromEntries(
            Object.entries({ limit, offset }).filter(([, value]) => value)
        )
        return Vue.axios
            .get(
                `${$themeConfig.app.backUrlDivisions}/notes/${noteId}/changes`,
                { params }
            )
            .then(response => {
                commit('SET_NOTE_HISTORY', response.data.changes)
                commit('SET_TOTAL_CHANGES', response.data.total)
                return response.data
            })
            .catch(error => {
                console.error(error)
                throw error
            })
    },

    createNote(_, noteData) {
        return Vue.axios
            .post(`${$themeConfig.app.backUrlDivisions}/notes`, noteData)
            .then(response => response.data)
            .catch(error => {
                console.error(error)
                throw error
            })
    },

    updateNote(_, { noteId, noteData }) {
        return Vue.axios
            .put(
                `${$themeConfig.app.backUrlDivisions}/notes/${noteId}`,
                noteData
            )
            .then(response => response.data)
            .catch(error => {
                console.error(error)
                throw error
            })
    },

    deleteNote(_, noteId) {
        return Vue.axios
            .delete(`${$themeConfig.app.backUrlDivisions}/notes/${noteId}`)
            .then(response => response.data)
            .catch(error => {
                console.error(error)
                throw error
            })
    },
}
